import React from "react";
import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function AboutPage() {
  const { t } = useLang();
  return (
    <>
      <SEO page="about" />
      <PageHero eyebrow={t.about.eyebrow} title={t.about.title} testId="about-hero" />

      <section className="bg-[#F7F8F5] py-24 md:py-32">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-7">
            <p className="text-lg md:text-xl text-[#061A26] leading-relaxed font-light" data-testid="about-copy">
              {t.about.copy}
            </p>
            <div className="mt-10 border-l-2 border-[#19C7C1] pl-6">
              <p className="text-base text-slate-600 italic leading-relaxed">{t.about.positioning}</p>
            </div>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-4 md:col-start-9">
            <div className="film-stack-lg" aria-hidden="true">
              <span /><span /><span /><span />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#061A26] py-24 md:py-32 relative overflow-hidden">
        <div className="absolute inset-0 film-lines opacity-30" aria-hidden="true" />
        <div className="relative max-w-[1100px] mx-auto px-6 md:px-10">
          <Reveal>
            <p className="eyebrow">{t.about.principlesTitle}</p>
          </Reveal>
          <div className="mt-12">
            {t.about.principles.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08} y={18}>
                <div className="group grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-8 py-8 border-b border-white/10 last:border-0 items-baseline" data-testid={`principle-${i}`}>
                  <span className="md:col-span-1 text-xs font-semibold text-[#19C7C1] tracking-widest tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="md:col-span-4 text-xl md:text-2xl font-light tracking-tight text-white group-hover:text-[#19C7C1] transition-colors duration-300">
                    {p.title}
                  </h3>
                  <p className="md:col-span-7 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
